import { withTranslation } from "react-i18next";
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Image, } from 'antd';
import { connect } from "react-redux";

// Local
import Text from "components/Text";

// Inner
import { useState } from "react";
import Title from "components/Title";
import styled from "styled-components";

const StyledContainer = styled.div`
  button.ant-btn-primary {
    background: ${ props => props.theme.buttonColor} !important;
  }
`;


/**
 * SelectEffect
 * @param {*} props 
 * @returns 
 */
const SelectEffect = (props) => {
  const [displayedNbIris, setDisplayedNbIris] = useState(null);

  let maxIrisEffects = 1;

  props.effects.forEach((effect) => {
    if (effect.iris > maxIrisEffects) {
      maxIrisEffects = effect.iris
    }
  })

  return (
      <StyledContainer
        theme={props.ui.theme}
      >
        {
          Array.from(Array(maxIrisEffects).keys()).filter((ie) => ie + 1 <= props.userIris.length).map((option) => (
            <>
              <div 
                style={{ display: 'flex', flexDirection: 'row', borderBottom: '1px solid lightgrey', marginBottom: 20, padding: 10 }}
                onClick={() => setDisplayedNbIris(displayedNbIris && displayedNbIris === option + 1 ? null : option + 1)}
              >
                <Title size={16}>Effet avec {option + 1} prise de vue</Title>
                {
                  displayedNbIris && displayedNbIris === option + 1 ? (
                    <UpOutlined style={{ marginLeft: 'auto', fontSize: 16, color: '#53b6ba' }} />

                  ) : (
                    <DownOutlined style={{ marginLeft: 'auto', fontSize: 16, color: '#53b6ba' }} />
                  )
                }
              </div>

              {
                option + 1 === displayedNbIris && props.effects.filter((effect) => !effect.default && effect.iris === option + 1).map((effect) => (
                  <div style={{ textAlign: 'center', marginBottom: 20 }}>
                    <Image 
                      src={props.getEffectUrl(effect)} 
                      width={320}
                      alt={effect.name}
                    />

                    <div style={{ display: 'flex', flexDirection: 'row', width: 320, margin: 'auto' }}>
                      <Text size={14} style={{ marginTop: 5 }} align="center">{effect.name}</Text>
                      <Button 
                        size="small" 
                        type="primary" 
                        style={{ margin: 5, marginTop: 5, marginLeft: 'auto', width: 'auto', fontSize: 12,  }} 
                        onClick={() => props.setSelectedEffect(effect)}
                      >
                        Sélectionner
                      </Button>
                    </div>
                  </div>
                ))
              }
              
            </>
          ))
        }
      </StyledContainer>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

export default connect(stateToProps)(withTranslation()(SelectEffect))